import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

interface IAddOn {
  add_ons: string[];
}

const cancelAddOns = (postData: IAddOn) => {
  return http().post(endpoints.accountBilling.addOns.cancel, postData);
};

export function useCancelAddOns() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: cancelAddOns,
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['fetchBillingDetails'] }),
  });
}
